import { useContext, useEffect } from 'react'
import { UserContext } from 'Contexts/UserContext/UserContext'
import { validateZip } from "Utilities/Location/Location"

const GeoLocation = ({ enabled = true }) => {

    const { context: userContext, updateUserZipCode, updateUserIsInternational } = useContext(UserContext)

    const requestGeoLocation = async () => {
        try {
            const res = await fetch('https://api.ipstack.com/check?access_key=d1f2dc908712c8edc8d9d38a1cec0367')
            const data = await res.json()
            if (!validateZip(data?.zip)) {
                throw `zip code from ip stack is not valid: ${data?.zip}`
            }

            updateUserZipCode(`${data.zip}`)
            updateUserIsInternational(data.country_code !== 'US')
        }
        catch (err) {
            console.error("error getting geolocation", err)
        }

    }

    useEffect(() => {
        if (userContext.hydrated && !userContext.zipCode && enabled && !userContext.isBot()) {
            requestGeoLocation();
        }
    }, [userContext?.hydrated, enabled])

    return false
}

export default GeoLocation